<template>

  <div class="EmptyCard card">
  
  </div>

</template>

<script>
export default {
  name: 'EmptyCard'
}
</script>

<style scoped>

.EmptyCard{
  height: 100px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/EmptyCard.vue